<div id="orders" class="page-layout contract-list-container carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center " fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row" fxLayoutGap="20px"
            fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'FUEL_INFORMATION_LIST' |translate}}</span>
            </div>
            <div>
                <button mat-raised-button (click)="fuelInformationAdd()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <!-- / HEADER -->
        <div class="content-card contract-table mb-20" style="justify-content: space-between;">

            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table [dataSource]="dataSource"
                    matSort [@animateStagger]="{value:'50'}" matSortActive="startDate" matSortDirection="desc" fusePerfectScrollbar>
    
                    <ng-container matColumnDef="city">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CITY'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.city!=null ? element.city:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="gasoline">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'GASOLINE'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.gasoline!=null ? element.gasoline:'---'}}
                        </mat-cell>
                    </ng-container>
                    
                    <ng-container matColumnDef="diesel">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DIESEL'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.diesel!=null ? element.diesel:'---'}}
                        </mat-cell>
                    </ng-container>
    
    
                    <ng-container matColumnDef="startDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'START_DATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.startDate!=null?(element.startDate | date:"dd/MM/y HH:mm"):'---'}}
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="endDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'END_DATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.endDate!=null?(element.endDate | date:"dd/MM/y HH:mm"):'---'}}
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATUS'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <a href="javascript:void(0)"
                                [ngStyle]="{'color': element.status?'green':'red','text-decoration': 'none'}"
                                (click)="FuelStatusChange(element)">{{element.status?("ACTIVE"|translate):("PASSIVE"|translate)}}</a>
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef >{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="deleteFuelInformation(element)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let element; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>